import { LINK_IDS, getLinkText } from '../nav-links';

export default {
  [getLinkText(LINK_IDS.INCIDENTS)]: [
    getLinkText(LINK_IDS.HOME),
    getLinkText(LINK_IDS.ALL_INCIDENTS),
    getLinkText(LINK_IDS.ALERTS),
    getLinkText(LINK_IDS.VISIBILITY),
    getLinkText(LINK_IDS.RECENT_CHANGES),
    getLinkText(LINK_IDS.POSTMORTEMS),
    getLinkText(LINK_IDS.POSTMORTEMS_PREVIEW),
    getLinkText(LINK_IDS.RESPONSE_PLAYS),
    getLinkText(LINK_IDS.CONFERENCE_BRIDGES),
  ],
  [getLinkText(LINK_IDS.SERVICES)]: [
    getLinkText(LINK_IDS.SERVICE_DIRECTORY),
    getLinkText(LINK_IDS.BUSINESS_SERVICES),
    getLinkText(LINK_IDS.IMPACT_METRICS),
    getLinkText(LINK_IDS.EVENT_RULES),
    getLinkText(LINK_IDS.EVENT_INTELLIGENCE),
  ],
  [getLinkText(LINK_IDS.PEOPLE)]: [
    getLinkText(LINK_IDS.MY_ON_CALL_SHIFTS),
    getLinkText(LINK_IDS.SCHEDULES),
    getLinkText(LINK_IDS.ESCALATION_POLICIES),
    getLinkText(LINK_IDS.USERS),
    getLinkText(LINK_IDS.TEAMS),
  ],
  [getLinkText(LINK_IDS.ANALYTICS)]: [
    getLinkText(LINK_IDS.REPORTS),
    getLinkText(LINK_IDS.REPORTS_PREVIEW),
    getLinkText(LINK_IDS.INTELLIGENT_DASHBOARDS),
    getLinkText(LINK_IDS.OPERATIONS_HEALTH),
    getLinkText(LINK_IDS.OPERATIONAL_REVIEWS),
  ],
  [getLinkText(LINK_IDS.STATUS_DASHBOARD)]: [getLinkText(LINK_IDS.STATUS_DASHBOARD)],
};
